export const GET_TEACHER_ROSTER_DETAILS = "GET_TEACHER_ROSTER_DETAILS";
export const GET_TEACHER_ROSTER_DETAILS_SUCCESS =
  "GET_TEACHER_ROSTER_DETAILS_SUCCESS";

export const UPDATE_ROSTERED_STUDENT_DATA = "UPDATE_ROSTERED_STUDENT_DATA";
export const UPDATE_ROSTERED_STUDENT_DATA_SUCCESS =
  "UPDATE_ROSTERED_STUDENT_DATA_SUCCESS";

export const UPLOAD_ROSTER_DATA = "UPLOAD_ROSTER_DATA";
export const UPLOAD_ROSTER_DATA_SUCCESS = "UPLOAD_ROSTER_DATA_SUCCESS";

export const VALIDATE_ROSTER_DATA = "VALIDATE_ROSTER_DATA";
export const VALIDATE_ROSTER_DATA_SUCCESS = "VALIDATE_ROSTER_DATA_SUCCESS";

export const DELETE_ROSTERED_STUDENT = "DELETE_ROSTERED_STUDENT";
export const DELETE_ROSTERED_STUDENT_SUCCESS =
  "DELETE_ROSTERED_STUDENT_SUCCESS";
